import { createSelector } from '@ngrx/store';

import { isMemberDataValid } from '@shared/state/members/selectors';

import { cartIsValidForPostingOnlineOrder } from '@shared/state/cart/selectors/cartIsValidForPostingOnlineOrder';
import { orderIsValidForPostingOnlineOrder } from '@shared/state/onlineOrder/selectors/orderIsValidForPostingOnlineOrder';

export const canPostOnlineOrder = createSelector(
    isMemberDataValid,
    cartIsValidForPostingOnlineOrder,
    orderIsValidForPostingOnlineOrder,
    (isMemberValid, isCartValid, isOrderDataValid) => isMemberValid && isCartValid && isOrderDataValid,
);
